import * as Yup from 'yup'

const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{5,}$/;
const timeRules = /^([01]\d|2[0-3]):([0-5]\d)$/;

export const locationSchema = (isUpdateModalOpen) => Yup.object().shape({
  name: Yup.string()
  .required('Name is required')
  .max(18, "Enter Valid Name")
  .min(3, "Enter minimum 3 characters")
  .matches(/^[A-Za-z ]+$/, 'Name must not contain special characters'),
    email: Yup.string().required("enter email")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Invalid email. Please use a valid email format, e.g., example@domain.com"
    ),
    // phone_number: Yup.number().positive().integer().required('Phone is required.').max(10, "Enter valid number 3311199872"),
    phone_number: Yup.string()
  .matches(/^[0-9]{11}$/, "Enter valid 11 digit number ")
  .required('Phone is required.'),
    description: Yup.string(),
    password: isUpdateModalOpen ? Yup.string().nullable() 
      : Yup.string()
        .min(6, 'Password must be at least 6 characters.')
        .matches(passwordRules , {message: 'Password must contain atleast 1 uppercase, 1 lowercase, 1 number and 1 special character.'})
        .required('Password is required.'),
    address: Yup.string().required('Address is required'),
    country: Yup.string().required('Country is required'),
    state: Yup.string().required('State is required'),
    city: Yup.string().required('City is Required'),
    postal_code: Yup.number().min(4).required('Postal Code is required'),
    opening_hours: Yup.string().matches(timeRules , {message: 'Please enter opening time in HH:MM format'}).required('Opening Hour is required.'),
    closing_hours: Yup.string().matches(timeRules , {message: 'Please enter closing time in HH:MM format'}).required('Closing Hour is required.'),
    member_id_temp: Yup.string().required('Member ID is required')
    .max(15, "Member ID must be at most 15 characters long")
    .matches(/^[A-Za-z0-9]+$/, 'Member ID must not contain spaces or special characters'),
  });
  export const assetSchema = (is_location) =>  {
  return Yup.object().shape({
    purchase_date: Yup.string()
  .required("Purchase date is required")
  .matches(
    /^\d{2}\/\d{2}\/\d{4}$/, 
    "Date must be in MM/DD/YYYY format"
  ),
    location_id: is_location ? Yup.string().nullable() : Yup.string().required("Location ID is required"),
    asset_name: Yup.string()
    .required('Name is required')
    .max(18, "Enter Valid Name")
    .min(3, "Enter minimum 3 characters")
    .matches(/^[A-Za-z ]+$/, 'Name must not contain special characters'),
    asset_type: Yup.string().required("Asset type is required"),
    purchase_date: Yup.date().required("Purchase date is required").nullable(),
    purchase_price: Yup.number().integer("  Enter without decimals").required("Enter Purchase Price ").positive("Price must be a positive number"),
    vendor: Yup.string().required("Vendor is required")   .min(2,"Name should contain minimum 2 characters").max(18,"Enter Valid Name"),
    warranty_period:Yup.string()
    .matches(/^(\d{1,2}(\.\d{1})?)$/, 'enter a valid warranty period')
    .required('number is required')
    .test('is-positive', 'Number must be positive', value => parseFloat(value) > 0),
    current_condition: Yup.string().required("Current condition is required"),
  })};


  export const visitorValidationSchema=Yup.object().shape({

    name: Yup.string()
    .required('Name is required')
    .max(18, "Enter Valid Name")
    .min(3, "Enter minimum 3 characters")
    .matches(/^[A-Za-z ]+$/, 'Name must not contain special characters'),
  
    email: Yup.string().required("enter email")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Invalid email. Please use a valid email format, e.g., example@domain.com"
    ),
    phone: Yup.string()
    .matches(/^[0-9]{12}$/, "Enter valid 11 digit number ")
    .required('Phone is required.'),
  
    address: Yup.string().required('Address is required'),
    country: Yup.string().required('Country is required'),
    state: Yup.string().required('State is required'),
    city: Yup.string().required('City is Required'),
    postal_code: Yup.string(),
    cnic: Yup.string()
    .matches(/^\d{1,13}$/, "CNIC must be exactly 13 digits and contain only numbers")
    .required("CNIC is required")
    .max(13, "CNIC cannot exceed 13 digits"),
  //   cnic: Yup.number()
  // .required("CNIC is required")
  // .max(13,"CNIC cannot exceed 13 digits"),


    age:Yup.number().positive("Enter positive number").integer('Enter without decimal').required("Age is required").max(75,"Enter valid age"),
    weight:Yup.number().positive(),
    height: Yup.number()
    .nullable()
    .typeError('Height must be a number')
    .positive('Height must be a positive number')
    .when('height_units', {
      is: 'ft',
      then: (schema) => schema.max(9, 'Height in feet should not be more than 9'),
      otherwise: (schema) => schema.max(280, 'Height in centimeters should not be more than 280'),
    }),
  height_units: Yup.string(),
    weight: Yup.number()
    .nullable()
    .typeError('Weight must be a number')
    .positive('Weight must be a positive number')
    .when('weight_units', {
      is: 'kg',
      then: (schema) => schema.max(300, 'Weight in kg should not be more than 300'),
      otherwise: (schema) => schema.max(661, 'Weight in pounds should not be more than 661'),
    }),
  
  weight_units: Yup.string(),
  
  
  })

  export const memberSchema = (isUpdateModalOpen , package_amount) => {
    return Yup.object().shape({
      name: Yup.string()
  .required('Name is required')
  .min(3, "Enter minimum 3 characters")
  .matches(/^[A-Za-z ]+$/, 'Name must not contain special characters'),
      email: Yup.string().required("enter email")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid email. Please use a valid email format, e.g., example@domain.com"
      ),
      password: isUpdateModalOpen ? Yup.string().nullable() 
      : Yup.string()
        .min(6, 'Password must be at least 6 characters.')
        .matches(passwordRules , {message: 'Password must contain atleast 1 uppercase, 1 lowercase, 1 number and 1 special character.'})
        .required('Password is required.'),
      phone: Yup.string()
      .min(12, "Phone number is invalid")
      // .matches(/^[0-9]{11}$/, "Enter a valid 11 digit number")
      .required('Phone is required.'),
      address: Yup.string().required('Address is required'),
      country: Yup.string().required('Country is required'),
      state: Yup.string().required('State is required'),
      city: Yup.string().required('City is Required'),
      postal_code: Yup.string(),
      // company_id:Yup.string().required('Company is required'),
      location_id:Yup.string().required('Location is required'),
      package_id: isUpdateModalOpen ? Yup.string().nullable() : Yup.string().required('Package is required'),
      // role:Yup.string().required('Role is required'),
      cnic: Yup.string()
      .matches(/^\d{13}$/, "CNIC must be exactly 13 digits and contain only numbers")
      .required("CNIC is required."),
      age:Yup.number().positive("Enter positive number").integer('Enter without decimal').required("Age is required").max(75,"Enter valid age"),
      emergency_contact: Yup.string()
      .required('Name is required')
      .min(3, "Enter minimum 3 characters")
      .matches(/^[A-Za-z ]+$/, 'Name must not contain special characters'),
      emergency_contact_no: Yup.string()
      .min(12, "Phone number is invalid")
      // .matches(/^[0-9]{11}$/, "Enter a valid 11 digit number")
      .required('Phone is required.'),
      emergency_relation: Yup.string().required('Relation is required'),
      // discount: Yup.number() .min(0, "Discount must be 0 or greater").integer().max(package_amount , "Discount amount cannot be greater than package fee").required('Discount is required'),
      height: Yup.number()
      .nullable()
      .typeError('Height must be a number')
      .positive('Height must be a positive number')
      .when('height_units', {
        is: 'ft',
        then: (schema) => schema.max(9, 'Height in feet should not be more than 9'),
        otherwise: (schema) => schema.max(280, 'Height in centimeters should not be more than 280'),
      }),
    height_units: Yup.string(),
      weight: Yup.number()
      .nullable()
      .typeError('Weight must be a number')
      .positive('Weight must be a positive number')
      .when('weight_units', {
        is: 'kg',
        then: (schema) => schema.max(300, 'Weight in kg should not be more than 300'),
        otherwise: (schema) => schema.max(661, 'Weight in pounds should not be more than 661'),
      }),
    weight_units: Yup.string(),
  });
  
      
  }
  
  
  export const facilitySchema = Yup.object().shape({
    location_id:Yup.string().required('Location is required'),
    name: Yup.string()
    .required('Name is required')
    .max(18, "Enter Valid Name")
    .min(3, "Enter minimum 3 characters")
    .matches(/^[A-Za-z ]+$/, 'Name must not contain special characters'),
    fee:Yup.number().integer("Enter without decimals").required("Fee is required").min(0, "Fee must be 0 or greater"),
  });

  export const ExpenseSchema = Yup.object().shape({
    location_id:Yup.string().required('Location is required'),
    title: Yup.string()
    .required('title is required')
    .max(18, "Enter Valid title")
    .min(3, "Enter minimum 3 characters")
    .matches(/^[A-Za-z ]+$/, 'Name must not contain special characters'),
    amount:Yup.number().integer("Enter without decimals").required("amount is required").min(0, "Fee must be 0 or greater"),
    category:Yup.string().required('Category is required'),
  });

  export const addonSchema = Yup.object().shape({
    title: Yup.string()
    .required('Name is required')
    .max(18, "Enter Valid Name")
    .min(3, "Enter minimum 3 characters")
    .matches(/^[A-Za-z ]+$/, 'Name must not contain special characters'),
    price: Yup.number().positive().integer().required('Price is required.'),
  });

  export const loginSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email.').required('Email is required.'),
    password: Yup.string()
      .required('Password is required.'),
  });

  export const ChangePasswordSchema = Yup.object().shape({
    // email: Yup.string().email('Invalid email.').required('Email is required.'),
    password: Yup.string().min(6, 'Password must be at least 6 characters.').required('Password is required.'),
    newPassword: Yup.string().min(6, 'Password must be at least 6 characters.').required('Password is required.'),
    confirmPassword: Yup.string().min(6, 'Password must be at least 6 characters.').required('Password is required.'),
  });

  export const roleSchema = Yup.object().shape({
    description: Yup.string().required('Description is required.'),
    name: Yup.string()
    .required('Name is required')
    .max(18, "Enter Valid Name")
    .min(3, "Enter minimum 3 characters")
    .matches(/^[A-Za-z ]+$/, 'Name must not contain special characters'),
  });

  export const permissionSchema = Yup.object().shape({
    description: Yup.string().required('Description is required.'),
    name: Yup.string()
    .required('Name is required')
    .max(18, "Enter Valid Name")
    .min(3, "Enter minimum 3 characters")
    .matches(/^[A-Za-z ]+$/, 'Name must not contain special characters'),
  });

  export const packageSchema = (isUpdateModalOpen) => {
    return Yup.object().shape({
      title: Yup.string()
      .required('Name is required')
      .min(3, "Enter minimum 3 characters")
      .matches(/^[A-Za-z ]+$/, 'Name must not contain special characters'),
    
      membership_fee: Yup.number().integer("  Enter without decimals").required(" Fee is required").positive("Price must be a positive number"),
      registration_fee: Yup.number()
        .nullable()
        .transform((value, originalValue) =>
          originalValue === '' || originalValue === null || originalValue === undefined
            ? null
            : value
        )
        .integer("  Enter without decimals")
        .positive("Price must be a positive number")
        .notRequired(),
      isFinite: Yup.boolean().default(false),
      duration: Yup.string().when('isFinite', {
        is: true,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.required('Duration is Required'),
      }),
      durationInDays: Yup.number().when('isFinite', {
        is: true,
        then: (schema) =>
          schema
            .required('Duration in days is required')
            .integer('Enter a whole number of days')
            .positive('Duration must be a positive number'),
        otherwise: (schema) =>
          schema
            .nullable()
            .transform((value, originalValue) =>
              originalValue === '' || originalValue === null || originalValue === undefined
                ? null
                : value
            )
            .notRequired(),
      }),
      // start_date: Yup.date()
        // .required('Date is required'),
      // end_date: Yup.date()
      // .required('Date is required')
      // .min(new Date(), 'Date cannot be in the past'),
      locationId:Yup.string().required('Location is required'),
      type:Yup.string().required('Package Type is required'),
      package_id_temp: Yup.string()
        .max(15, 'Package ID prefix must be at most 15 characters long')
        .matches(/^$|^[A-Za-z0-9]+$/, 'Package ID prefix must be alphanumeric with no spaces'),
    });
  }




  
export const staffMemberValidationSchema = (is_location, isUpdate = false) => { 
  return Yup.object().shape({
  location_id: is_location ? Yup.string().nullable() : Yup.string().required('Location ID is required'),
  name: Yup.string()
  .required('Name is required')
  .max(18, "Enter Valid Name")
  .min(3, "Enter minimum 3 characters")
  .matches(/^[A-Za-z ]+$/, 'Name must not contain special characters'),

  email: Yup.string().required("enter email")
  .matches(
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    "Invalid email. Please use a valid email format, e.g., example@domain.com"
  ),
  phone_number: Yup.string()
  // .matches(/^[0-9]{11}$/, "Enter valid 11 digit number ")
  .required('Phone is required.'),
  address: Yup.string().required('Address is required'),
  designation: Yup.string().required('Designation is required'),
  salary: Yup.string()
  .matches(/^(?!\+)[0-9]+$/, 'Salary must bepositive with no special characters')
  .required('Salary is required'),

  hire_date: Yup.string().required('Hire date is required'),
  employment_status: Yup.string().required('Employment status is required'),
  work_schedule: Yup.string(),
  additional_notes: Yup.string(),
  password: Yup.string()
    .nullable()
    .test(
      "portal-bundle-password",
      isUpdate
        ? "Password must be at least 6 characters when set"
        : "Password is required when a role is selected",
      function (value) {
        const role = this.parent.role;
        const hasRole = role != null && String(role).trim() !== "";
        const hasPassword = value != null && String(value).trim() !== "";
        if (isUpdate) {
          if (hasPassword && String(value).length < 6) return false;
          return true;
        }
        if (hasRole && !hasPassword) return false;
        if (hasPassword && String(value).length < 6) return false;
        return true;
      }
    ),
  role: Yup.string()
    .nullable()
    .test(
      "portal-bundle-role",
      isUpdate
        ? "Role is required when setting a new password for first-time access"
        : "Role is required when a password is set",
      function (value) {
        const password = this.parent.password;
        const hasRole = value != null && String(value).trim() !== "";
        const hasPassword = password != null && String(password).trim() !== "";
        if (isUpdate) {
          // On update, role alone is fine; password alone only OK if they already had access (validated server-side)
          return true;
        }
        if (hasPassword && !hasRole) return false;
        return true;
      }
    ),
})};
  


  export const SignupSchema = Yup.object().shape({
    companyName: Yup.string()
      .min(4, "Name must be at least 4 characters.")
      .required("Name is required."),
       email :  Yup.string().required("enter email")
       .matches(
         /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
         "Invalid email. Please use a valid email format, e.g., example@domain.com"
       ),
      
    password: Yup.string()
      .min(6, "Password must be at least 6 characters.")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter.")
      .matches(/[!@#$%^&*(),.?\":{}|<>]/, "Password must contain at least one special character.")
      .required("Password is required."),
    confirmPassword: Yup.string()
      .required("Please confirm your password.")
      .oneOf([Yup.ref("password"), null], "Passwords must match."),
    contact: Yup.string()
    .matches(/^[0-9]{11}$/, "Enter valid 11 digit number ")
    .required('Phone is required.'),
  });
  
  export const personalTrainerSchema = (isUpdateModalOpen , is_location) => {
    return Yup.object().shape({
    location_id: is_location ? Yup.string().nullable() : Yup.string().required('Location ID is required'),
    name: Yup.string().required('Name is required').min(3 , 'Name must be atleast 3 charachters'),
    email:  Yup.string().required("enter email")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Invalid email. Please use a valid email format, e.g., example@domain.com"
    ),
    phone_number: Yup.string()
    .matches(/^[0-9]{11}$/, "Enter a valid 11 digit number")
    .required('Phone is required.'),
    address: Yup.string().required('Address is required'),
    hire_date: Yup.string().required('Hire date is required'),
    employment_status: Yup.string().required('Employment status is required'),
    monthly_rate: Yup.number().integer("Enter without decimals").required("Monthly Fee is required").positive("Monthly Fee must be a positive number"),

    experience_years:Yup.string()
    .matches(/^(\d{1,2}(\.\d{1})?)$/, 'Experience must be a 1-2 digit number or a decimal with one place')
    .required('Experience is required'),
  
    availability: Yup.array()
    .of(Yup.string().required("Each day must be a string")) 
    .min(1, "At least one day must be selected") 
    .required("Availability is required"),
    password: isUpdateModalOpen ? Yup.string().nullable() 
    : Yup.string()
      .min(6, 'Password must be at least 6 characters.')
      .matches(passwordRules , {message: 'Password must contain atleast 1 uppercase, 1 lowercase, 1 number and 1 special character.'})
      .required('Password is required.'),
    role: Yup.string().nullable(),
  })}



//   confirm_password: Yup.string()
//       .min(6, 'Password must be at least 6 characters.')
//       .matches(passwordRules , {message: 'Please create stronger password'})
//       .required('Password is required.'),


// email: Yup.string().email('Invalid email.').required('Email is required.'),
